import path from "path";
import { isProdStage } from "./util/stageUtils";
import KatalLogger from "@amzn/katal-logger";

let defaultPath = "/dev/null";

if (process.env.IS_BUILD !== "true" && process.env.STAGE) {
  defaultPath = "/var/log/application_log_pipe";
}

const prodApiGatewayEndpoint =
  "https://u831naskbb.execute-api.us-east-1.amazonaws.com/prod/v1/log";
const betaApiGatewayEndpoint =
  "https://9zvb2n86n1.execute-api.us-west-2.amazonaws.com/prod/v1/log";

function getLoggerUrl(): string {
  return isProdStage() ? prodApiGatewayEndpoint : betaApiGatewayEndpoint;
}

interface GenericLoggerInterface {
  info: (str: string) => void;
  debug: (str: string) => void;
  error: (str: string) => void;
}
let logger: GenericLoggerInterface;

function localLogger() {
  logger = {
    info: (str) => console.log(`[INFO] ${str}`),
    debug: (str) => console.log(`[DEBUG] ${str}`),
    error: (str) => console.error(`[ERROR] ${str}`),
  };

  return logger;
}

if (process.env.STAGE === "local") {
  logger = localLogger();
} else {
  const loggerUrl = getLoggerUrl();
  if (loggerUrl) {
    console.log("Remote logger url found, configuring remote logger");
    const katalogger = new KatalLogger({
      url: loggerUrl,
      logToConsole: true,
    });
    logger = katalogger;
  } else {
    console.log("No logger url found, configuring console logger");
    logger = localLogger();
  }
}

export default logger;
